var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jade-feedback" },
    [
      _c("jade-icon-shape", {
        attrs: { size: "large", variant: _vm.variant, use: _vm.computedIcon },
      }),
      _c(
        "div",
        { staticClass: "jade-feedback__content" },
        [
          _c(
            "jade-text",
            {
              attrs: {
                variant: "display-small",
                color: "high",
                "data-testid": "title-text",
              },
            },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
          _vm.description
            ? _c(
                "jade-text",
                {
                  attrs: {
                    variant: "text-medium",
                    weight: "regular",
                    color: "medium",
                    "data-testid": "description-text",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.description) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }